import { DataSource } from '@angular/cdk/collections';
import { ArlDataFromFile } from '@dave/types';
import { Observable, switchMap } from 'rxjs';
import { debounceTime, map, startWith } from 'rxjs/operators';
import { SearchQueriesDebounceTime, stringSearch } from '../../../helper/helper';
import { MatLegacyPaginator } from '@angular/material/legacy-paginator';
export interface SelectGaebArlDataTableItem {
    matchedArlId: number,
    price: number,
    articleNumber: string,
    name: string,
    itemNumber: string,
}
export class SelectGaebArlDataTableDatasource extends DataSource<SelectGaebArlDataTableItem> {
    searchQuery$: Observable<string>;
    paginator: MatLegacyPaginator | undefined;

    data: SelectGaebArlDataTableItem[]
    constructor(data: ArlDataFromFile[]) {
        super();
        this.data = data.map(d => ({
            matchedArlId: d.matchedArlId && +d.matchedArlId,
            price: d.Price && +d.Price/100,
            articleNumber: d.ArticleNumber,
            name: d.Name,
            itemNumber: d.ItemNumber,
        }))
    }
    connect(): Observable<SelectGaebArlDataTableItem[]> {
        if (this.searchQuery$ && this.paginator) {
            return this.searchQuery$.pipe(
                debounceTime(SearchQueriesDebounceTime),
                startWith(''),
                switchMap(searchQuery => this.paginator.page.pipe(
                    startWith(null),
                    map(() => this.getPagedData([...getFilteredData(this.data, searchQuery)]))
                ))
            )
        } else {
            throw new Error('searchQuery$ not set');
        }
    }

    disconnect(): void {
    }
    /**
     * Paginate the data (client-side). If you're using server-side pagination,
     * this would be replaced by requesting the appropriate data from the server.
     */
    private getPagedData(data: SelectGaebArlDataTableItem[]): SelectGaebArlDataTableItem[] {
        if (this.paginator) {
            const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
            return data.splice(startIndex, this.paginator.pageSize);
        } else {
            return data;
        }
    }
}
const getFilteredData = (data: SelectGaebArlDataTableItem[], searchQuery: string | null) => {
    if (!searchQuery?.length) {
        return data;
    }
    return data.filter(item => [item.itemNumber, item.articleNumber, item.name, item.price?.toString()].some(v => stringSearch(v, searchQuery)))
}
